import { number, object } from "yup";

export const TaximeterRatesValidationSchema = object({
  startPrice: number().required("Задолжително"),
  pricePerKm: number().required("Задолжително"),
  pricePerMinute: number().required("Задолжително"),
});
